import React, { useContext, useState } from "react";
import { get, parseInt, isEmpty } from "lodash";
import { OverlayTrigger, Tooltip, Row, Col, Form } from "react-bootstrap";
import {
  GetInitials,
  EditActionSlider,
  AddTreeStructure,
  SliderPanel,
  LoaderWrapper,
  ManageDistributionLayoutNew,
  EmployeeDetailsCard,
} from "../../../components";
import {
  FLOW_TYPES,
  getAdvancedPathWithParam,
  getCommaSeparatedValuesFromArr,
  getDateWithSlash,
  getFormattedSsn,
  getNullTableItem,
  getPathWithParam,
  MANAGE_CENSUS_ROUTES,
  ROUTES,
  ssnMasking,
  getWithdrawalName,
  MANAGE_TRANSACTION_ROUTES,
  MANAGE_DISTRIBUTION_ROUTES,
  MANAGE_COMPANY_ROUTES,
  manageDistributionFormNames,
  distributionFormFields,
  OPTIONS_DATA_MAPPER,
} from "../../../utils";
import AddToolTip from "../../../components/AddToolTip";
// import employeeImage from "../../../assets/sample_image.png";

import { EmployeeStatus } from "../../../layouts";
import { useDeepEffect, useRequest, useRouterParams } from "../../../abstracts";
import {
  getEmployeeImage,
  getCompanyLogo,
  getWithdrawalRequest,
  getBalances,
  approvalWithdrawalRequest,
  submitWithdrawalRequest,
  getEmployeePlanWithdrawals,
  getEmployeeCensusInformation,
} from "../../../services";
import { Link, useHistory } from "react-router-dom";
import ManageDistributionLayout from "../../../components/ManageDistributionLayout/ManageDistributionLayout";
import { Formik } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import {
  appLayoutStore,
  manageDistributionStore,
  manageTransactionStore,
  setManageDistributionToastInfo,
  setWithdrawalRequestPageData,
} from "../../../contexts";
import {
  faExclamationCircle,
  faInfoCircle,
  faCheckCircle,
  faTimesCircle,
  faPrint,
} from "@fortawesome/pro-light-svg-icons";
import PayeeDetailsCard from "../../../components/PayeeDetailsCard/PayeeDetailsCard";
import { setManageTransactionToastInfo } from "./../../../contexts/reducers/manage-transaction/actions";
import { CalculateSourceSplit } from "../WithdrawalRequestContainer/CalculateSourceSplitup";
import { globalToastInfo } from "./../../../contexts/reducers/app-layout/actions";
import WithdrawalAllocationCard from "./WithdrawalAllocationCard";
import {
  calculateGrossAmountFromNetAmountSourceWise,
  calculateNetAmountFromGrossAmount,
  CalculateProrationSplitUp,
  calculateRequestedAmountEffective,
  calculationToBeBasedOnGrossAmount,
  DeductProratedSplits,
  getFilteredRkData,
  getSourceWiseRequestAmountModel,
  getValues,
  GetWithdrawalAmountBasedOnStrategy,
  GetWithdrawalStrategy,
  isAllowMeToChooseTransaction,
  SourceAllocationCalculationMethod,
  SourceBalancesAfterVestingMultiplier,
  withdrawalTypeEnum,
} from "../WithdrawalRequestContainer/DistributionConstantsAndFunctions";
import PaymentScheduleTable from "../WithdrawalRequestContainer/PaymentScheduleTable";

const formName = manageDistributionFormNames.WITHDRAWAL_REQUEST;
const fields = distributionFormFields[formName];

function WithdrawalSummaryComponent(props) {
  const {
    responseModel,
    state,
    setResponseModel,
    setResponseLoading,
    filteredValues,
    setSliderOpen1,
    ...rest
  } = props;
  const isQBAD = responseModel.withdrawalType === withdrawalTypeEnum.QBAD;
  console.log("responseModel", responseModel);
  const { censusId, flow, withdrawalRequestId, fromPage } = useRouterParams();
  const getSplits = (allocatedSourceWithdrawals) => {
    let allSourceWithdrawals = [];
    for (var i = 0; i < allocatedSourceWithdrawals.length; i++) {
      allSourceWithdrawals = allSourceWithdrawals.concat(
        allocatedSourceWithdrawals[i]
      );
    }
    let reducedSourceWithdrawals = {};
    allSourceWithdrawals.forEach((_) => {
      let sourceInv = {
        ...get(reducedSourceWithdrawals, `${_.sourceId}.subHead`, {}),
      };
      get(_, "sourceInvestmentBalances", []).forEach((inv) => {
        sourceInv[inv.investmentId] = {
          id: inv.investmentId,
          amount:
            getValues(inv?.sourceEmployeeInvestmentMap?.accountBalance) +
            getValues(get(sourceInv, inv.investmentId, {}).amount),
          name: inv.investmentName ?? "-",
        };
      });
      reducedSourceWithdrawals[_.sourceId] = {
        id: _.sourceId,
        head: _.sourceName,
        amount:
          getValues(get(reducedSourceWithdrawals, _.sourceId, {}).amount) +
          getValues(_?.sourceEmployeeMap?.accountBalance),
        subHead: sourceInv,
      };
    });

    return Object.keys(reducedSourceWithdrawals).map((_) => {
      return {
        ...reducedSourceWithdrawals[_],
        subHead: Object.keys(
          get(reducedSourceWithdrawals[_], "subHead", {})
        ).map((x) => get(reducedSourceWithdrawals[_], `subHead.${x}`, {})),
      };
    });
  };

  const parseData = (employeePlanWithdrawals, withdrawalRequestData) => {
    let beneficiaries = employeePlanWithdrawals?.beneficiaries;
    if (!isEmpty(employeePlanWithdrawals?.employeePlans)) {
      let planIndex =
        employeePlanWithdrawals.employeePlans.findIndex(
          (x) => x.id == withdrawalRequestData?.planId
        ) ?? 0;
      let withdrawalIndex =
        employeePlanWithdrawals.employeePlans[
          planIndex
        ]?.withdrawals?.findIndex(
          (x) => x.id == withdrawalRequestData?.withdrawalId
        ) ?? 0;
      let selectedPlan = employeePlanWithdrawals.employeePlans[planIndex];
      let selectedWithdrawal =
        employeePlanWithdrawals.employeePlans[planIndex]?.withdrawals[
          withdrawalIndex
        ];

      return {
        beneficiaries: beneficiaries ?? [],
        selectedPlan: selectedPlan,
        selectedWithdrawal: selectedWithdrawal,
      };
    }
  };

  const calculateFeeAndTaxSplitForEachTransaction = (
    transaction,
    withdrawalRequestData,
    filteredSourceBalances
  ) => {
    // let filteredSourceBalances = getFilteredRkData(
    //   sourceBalances,
    //   false,
    //   withdrawalRequestData,
    //   transaction,
    //   0
    // );
    const netAmount = transaction[fields.requestedAmount];
    const grossAmountEffective = transaction[fields.grossAmount];
    const totalFeeEffective =
      getValues(transaction[fields.eftFee]) +
      getValues(transaction[fields.checkFee]);
    const grossAmountAfterFeeDeduction =
      grossAmountEffective - totalFeeEffective;
    const effectiveTaxesAndPenalty = grossAmountAfterFeeDeduction - netAmount;
    const totalTaxes =
      getValues(transaction[fields.federalTax]) +
      getValues(transaction[fields.stateTax]) +
      getValues(transaction[fields.earlyWithdrawalPenalty]) +
      getValues(transaction[fields.waiveOffLimit]);
    const stateTax =
      (effectiveTaxesAndPenalty * getValues(transaction[fields.stateTax])) /
      totalTaxes;
    const federalTax =
      (effectiveTaxesAndPenalty * getValues(transaction[fields.federalTax])) /
      totalTaxes;
    const checkFee = getValues(transaction[fields.checkFee]);
    const eftFee = getValues(transaction[fields.eftFee]);
    const rollOverFee = getValues(transaction[fields.rollOverFee]);
    const penalty =
      (effectiveTaxesAndPenalty *
        (getValues(transaction[fields.earlyWithdrawalPenalty]) +
          getValues(transaction[fields.waiveOffLimit]))) /
      totalTaxes;
    return { stateTax, federalTax, eftFee, checkFee, penalty, rollOverFee };
  };

  const employeePlanWithdrawalDataFromCache = get(
    state,
    "employeePlansWithdrawal",
    []
  );
  const data = get(state, "withdrawalRequestData", []);
  const parsedData = parseData(employeePlanWithdrawalDataFromCache, data);
  const [employeePlans, setEmployeePlans] = useState(parsedData?.selectedPlan);
  const sourceBalances = get(employeePlans, "sourceBalances", []);
  const [sourceSplit, setSourceSplit] = useState([]);
  const [withdrawal, setWithdrawal] = useState(parsedData?.selectedWithdrawal);
  const employeeData = get(state, "api.censusInformation");
  const [beneficiaryDetails, setBeneficiaryDetails] = useState(
    parsedData?.beneficiaries ?? []
  );
  function getFileNameFromBlobPath(url) {
    return url?.split("/").pop().split("_")[0];
  }
  function getFileExtensionFromBlobPath(url) {
    return url
      ?.split("/")
      .pop()
      .split("_")[1]
      .slice(
        ((url.split("/").pop().split("_")[1].lastIndexOf(".") - 1) >>> 0) + 2
      );
  }

  const feeAndTaxSplitForEachTransaction = get(
    responseModel,
    "withdrawalTransactions",
    []
  ).map((_) => _[fields.feeAndTaxSplit]);

  const getSplitsByWithdrawalTransaction = (
    sourceBalances,
    withdrawalRequestData,
    withdrawalTransactionData
  ) => {
    let final = [];
    const filteredSourceBalances = getFilteredRkData(
      sourceBalances,
      false,
      withdrawalRequestData,
      withdrawalTransactionData,
      0
    );
    // if (
    //   withdrawalTransactionData.sourceAllocationCalculationMethod ===
    //   SourceAllocationCalculationMethod.AllowMeToChoose
    // ) {
    //   return get(withdrawalTransactionData, "allocatedSourceWithdrawal", []);
    // } else {

    let sourceWiseRequestAmount = getSourceWiseRequestAmountModel(
      withdrawalTransactionData
    );
    const withdrawalAmountSplit = GetWithdrawalAmountBasedOnStrategy(
      GetWithdrawalStrategy(withdrawalTransactionData),
      filteredSourceBalances ?? [],
      withdrawalTransactionData?.sourceHierarchyDetails ?? [],
      get(withdrawalTransactionData, fields.requestedAmount) ?? 0,
      sourceWiseRequestAmount
    );
    return withdrawalAmountSplit;
    // return CalculateProrationForSourceAllocation(
    //   filteredSourceBalances ?? [],
    //   withdrawalTransactionData.requestedAmount ?? 0,
    //   false
    // );
    // }
    // return final;
  };

  useDeepEffect(() => {
    var plan = {};
    var selectedWithdrawal = {};
    if (withdrawalRequestId) {
      setResponseLoading(true);
      getWithdrawalRequest(withdrawalRequestId).then((response) => {
        getEmployeePlanWithdrawals(censusId)
          .then((res) => {
            const {
              selectedPlan,
              selectedWithdrawal,
              beneficiaries,
            } = parseData(res, response);

            const tempResponseModel = {
              ...(response || {}),
              [fields.withdrawalTransactions]: (
                response.withdrawalTransactions ?? []
              )?.map((_) => {
                const sourceBalances_ = get(selectedPlan, `sourceBalances`);
                const sourceBalancesAfterVestingMultiplier = SourceBalancesAfterVestingMultiplier(
                  sourceBalances_
                );
                const sourceBalancesAfterDeductingWithdrawalFee = DeductProratedSplits(
                  sourceBalancesAfterVestingMultiplier,
                  CalculateProrationSplitUp(
                    sourceBalancesAfterVestingMultiplier,
                    response[fields.withdrawalFee],
                    [],
                    false
                  ),
                  1
                );
                const filteredSourceBalance = getFilteredRkData(
                  sourceBalancesAfterDeductingWithdrawalFee,
                  false,
                  response,
                  _,
                  0
                );
                // const grossAmountInitial = calculateGrossAmountFromNetAmountSourceWise(
                //   _,
                //   response,
                //   filteredSourceBalance
                // );
                const grossAmountInitial =
                  !calculationToBeBasedOnGrossAmount(response) ||
                  isAllowMeToChooseTransaction(_)
                    ? calculateGrossAmountFromNetAmountSourceWise(
                        {
                          ..._,
                          [fields.grossAmount]: _[fields.requestedAmount],
                        },
                        response,
                        filteredSourceBalance
                      )
                    : _[fields.requestedAmount];
                const requestedAmountInitial = calculateRequestedAmountEffective(
                  response,
                  { ..._, [fields.grossAmount]: _[fields.requestedAmount] },
                  filteredSourceBalance
                );
                // calculateNetAmountFromGrossAmount(
                //   { ..._, [fields.grossAmount]: _[fields.requestedAmount] },
                //   response,
                //   filteredSourceBalance
                // ).reduce(
                //   (a, b) => a + getValues(b?.sourceEmployeeMap?.accountBalance),
                //   0
                // );

                const effectiveWithdrawalTransaction = {
                  ..._,
                  [fields.requestedAmount]: requestedAmountInitial,
                  [fields.grossAmount]: grossAmountInitial,
                };

                const feeAndTaxSplit = calculateFeeAndTaxSplitForEachTransaction(
                  effectiveWithdrawalTransaction,
                  responseModel,
                  filteredSourceBalance
                );
                return {
                  ...effectiveWithdrawalTransaction,
                  [fields.feeAndTaxSplit]: feeAndTaxSplit,
                };
              }),
            };
            setResponseModel(tempResponseModel);

            setBeneficiaryDetails(beneficiaries);
            if (!isEmpty(res?.employeePlans)) {
              setEmployeePlans(selectedPlan);
              setWithdrawal(selectedWithdrawal);
              setSourceSplit(
                get(response, "withdrawalTransactions", []).map(
                  (transaction) => {
                    return getSplitsByWithdrawalTransaction(
                      get(selectedPlan, "sourceBalances", []),
                      response,
                      transaction
                    );
                  }
                )
              );
            }
            setResponseLoading(false);
          })
          .catch((ex) => {
            setResponseLoading(false);
          });
      });
    } else
      setSourceSplit(
        get(responseModel, "withdrawalTransactions", []).map((transaction) => {
          return getSplitsByWithdrawalTransaction(
            sourceBalances,
            responseModel,
            transaction
          );
        })
      );
  }, []);

  const withdrawalName = getWithdrawalName(
    state?.withdrawalType ?? withdrawal?.withdrawalType
  );
  const totalCheckFee = feeAndTaxSplitForEachTransaction?.reduce(
    (a, object) => a + object?.checkFee,
    0
  );
  const totalEftFee = feeAndTaxSplitForEachTransaction?.reduce(
    (a, object) => a + object?.eftFee,
    0
  );
  const totalRequestAmount = responseModel?.withdrawalTransactions?.reduce(
    (a, object) => a + object?.requestedAmount,
    0
  );
  const totalGrossAmount = responseModel?.withdrawalTransactions?.reduce(
    (a, object) => a + object?.grossAmount,
    0
  );
  const totalWithdrawalFee = responseModel?.withdrawalFee;
  const totalRollOverFee = feeAndTaxSplitForEachTransaction?.reduce(
    (a, object) => a + object?.rollOverFee,
    0
  );

  const totalStateTax = feeAndTaxSplitForEachTransaction?.reduce(
    (a, object) => a + object?.stateTax,
    0
  );
  const totalFederalTax = feeAndTaxSplitForEachTransaction?.reduce(
    (a, object) => a + object?.federalTax,
    0
  );
  const totalPenatly = feeAndTaxSplitForEachTransaction?.reduce(
    (a, object) => a + object?.penalty,
    0
  );
  const totalFeesAndTaxes =
    getValues(totalEftFee) +
    getValues(totalCheckFee) +
    getValues(totalWithdrawalFee) +
    getValues(totalRollOverFee) +
    getValues(totalStateTax) +
    getValues(totalFederalTax) +
    getValues(totalPenatly);

  const taxAndFeesInnerStructure = () => {
    let result = [];
    totalWithdrawalFee &&
      result.push({ amount: totalWithdrawalFee, name: "Withdrawal Fee" });
    totalRollOverFee &&
      result.push({ amount: totalRollOverFee, name: "RollOver Fee" });
    totalEftFee && result.push({ amount: totalEftFee, name: "EFT Fee" });
    totalCheckFee && result.push({ amount: totalCheckFee, name: "Check Fee" });
    totalPenatly && result.push({ amount: totalPenatly, name: "Penalty" });
    result.push({ amount: totalStateTax, name: "State Tax" });
    result.push({ amount: totalFederalTax, name: "Federal Tax" });
    return result;
  };

  const taxAndFeesStructure = [
    {
      head: "Fee & Tax details",
      amount: totalFeesAndTaxes,
      subHead: taxAndFeesInnerStructure(),
    },
  ];
  const periodicPaymentFrequency =
    responseModel[fields.dateOfAnnuityPayments] === 1
      ? withdrawal?.paymentFrequencyApplicable
      : responseModel[fields.frequency];

  return (
    <>
      <div className="p-20 overflow-auto H-80 W-100">
        <h4 className="ft-16 fw-600 mt-20 mb-20 d-flex w-80">
          Request Summary
          <div className="ml-auto primary-small">
            <FontAwesomeIcon icon={faPrint} /> Print
          </div>
        </h4>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "80%",
            marginBottom: "30px",
            padding: "10px",
            border: "1px solid #D8D8DC",
            borderRadius: "5px",
            backgroundColor: "#F6F6F6",
            alignItems: "center",
          }}
        >
          <FontAwesomeIcon
            icon={faInfoCircle}
            style={{ marginTop: "2px", marginRight: "10px" }}
          />
          <p
            style={{
              marginBottom: "0px",
              fontSize: "14px",
              fontWeight: "400",
              color: "#333333",
            }}
          >
            {`Below is a summary of your ${withdrawalName} request application. Please
        review prior to submitting the withdrawal request.`}
          </p>
        </div>

        <p className="ft-16 fw-600">Plan Details</p>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "80%",
            marginBottom: "30px",
            padding: "20px 150px 20px 35px",
            border: "1px solid #D8D8DC",
            borderRadius: "5px",
            backgroundColor: "#F6F6F6",
          }}
        >
          <div>
            <p
              style={{
                marginBottom: "5px",
                fontSize: "14px",
                fontWeight: "400",
                color: "#000000",
              }}
            >
              Plan Name{" "}
            </p>
            <p
              style={{
                margin: "0px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#000000",
              }}
            >
              {state?.planName ?? employeePlans?.planName}
            </p>
          </div>
          <div>
            <p
              style={{
                marginBottom: "5px",
                fontSize: "14px",
                fontWeight: "400",
                color: "#000000",
              }}
            >
              Plan ID
            </p>
            <p
              style={{
                margin: "0px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#000000",
              }}
            >
              {state?.rkPlanNumber ?? employeePlans?.rkPlanNumber}
            </p>
          </div>
        </div>
        <p className="fw-bold">Withdrawal Details</p>
        <div className="distribution-card">
          <div className="fw-bold ft-16 mt-4">{withdrawalName} withdrawal</div>
          <hr />
          <ul
            className=""
            style={{
              listStyle: "none",
              paddingInlineStart: "0px",
            }}
          >
            <li className="mb-3">
              <div className="d-flex justify-content-space-between">
                <div className="fw-bold ft-15">Requested Amount</div>
                <div className="fw-bold ft-15">
                  ${totalRequestAmount?.toFixed(2)}
                </div>
              </div>
              <div className="ft-14 mt-2" style={{ color: "#7C7C80" }}>
                {" "}
                {responseModel?.modeOfPayment === 1
                  ? "Onetime payment"
                  : "Periodic payment"}
              </div>
              {responseModel?.modeOfPayment === 2 && (
                <div className="ft-14 fw-bold">
                  {`${
                    OPTIONS_DATA_MAPPER.PERIODIC_PAYMENT_OPTIONS[
                      responseModel?.periodicPaymentType
                    ]
                  } - ${
                    OPTIONS_DATA_MAPPER.PAYROLLFREQUENCY_TYPE[
                      periodicPaymentFrequency
                    ]
                  }`}
                </div>
              )}
            </li>
            <div
              style={{
                marginLeft: "-25px",
                marginRight: "-10px",
              }}
            >
              <AddTreeStructure data={taxAndFeesStructure} />
            </div>
            <li>
              <div className="d-flex mt-2 justify-content-space-between">
                <p className="fw-bold ft-15">Gross Withdrawal Amount</p>
                <p className="fw-bold ft-15">
                  $
                  {(calculationToBeBasedOnGrossAmount(responseModel)
                    ? totalGrossAmount
                    : totalRequestAmount + totalFeesAndTaxes
                  )?.toFixed(2)}
                </p>
              </div>
            </li>
            <div className="dashed-line-separator" />
            <div className="d-flex flex-row mt-n20 float-right">
              <FontAwesomeIcon
                icon={faExclamationCircle}
                className="pt-1 mr-1"
              />
              <p className=""> Fees and tax deducted from account balance</p>
            </div>
          </ul>
        </div>

        <p style={{ fontWeight: "bold", marginTop: "24px" }}>
          Withdrawal Allocation
        </p>
        <div className="distribution-card mb-4">
          <div className="d-flex justify-content-between mt-20">
            <div> Requested Amount</div>{" "}
            <div>
              $
              {get(responseModel, `withdrawalTransactions`, [])
                .reduce((a, b) => a + b.requestedAmount, 0)
                .toFixed(2)}
            </div>{" "}
          </div>
          <div>
            {get(responseModel, `withdrawalTransactions`, []).map((val) => {
              return (
                <>
                  <WithdrawalAllocationCard
                    filteredValues={filteredValues}
                    beneficiaryDetails={beneficiaryDetails}
                    withdrawalTransactionData={val}
                    style={{ margin: "20px 0px" }}
                  />
                </>
              );
            })}
          </div>
        </div>

        <p className="fw-bold"> {"Source & Investment Splitup"}</p>
        <div className="distribution-card mb-4">
          <div className="d-flex justify-content-space-between mt-4">
            <div className="ft-16 fw-bold">Net Withdrawal Amount</div>
            <div>${totalRequestAmount?.toFixed(2)}</div>
          </div>
          <div className="line-separator" />
          <AddTreeStructure
            style={{
              paddingInlineStart: "0px",
              marginLeft: "-25px",
            }}
            data={getSplits(sourceSplit)}
          />
        </div>

        {responseModel[fields.modeOfPayment] === 2 && (
          <>
            <div className="fw-bold ft-16 mt-4">Payment Schedule</div>
            {/* <div
                style={{ color: "#919191" }}
                className="d-flex flex-row"
              >
                <FontAwesomeIcon
                  className="fw-300 ft-14 mr-1"
                  icon={faExclamationCircle}
                />
                <p className="fw-400 ft-12 ">
                  The generated payment schedule is tentative
                  in nature & subjected to changes due to
                  market fluctuations
                </p>
              </div> */}
            <div style={{ color: "#7C7C80" }} className="ft-14 fw-bold mb-3">
              {
                OPTIONS_DATA_MAPPER.PAYROLLFREQUENCY_TYPE[
                  periodicPaymentFrequency
                ]
              }{" "}
              frequency
            </div>
            <div className="withdrawal-request-contrainer-new mb-4 w-80">
              <PaymentScheduleTable
                sourceBalances={sourceBalances}
                fields={fields}
                values={responseModel}
                selectedWithdrawalPlanSetUp={withdrawal}
                periodicPaymentAmount={
                  responseModel?.withdrawalAmountPerFrequency ??
                  responseModel?.netPeriodicPaymentAmount
                }
                withdrawalTransactionForPeriodicPayment={get(
                  responseModel,
                  "withdrawalTransactions.0",
                  {}
                )}
                periodicPaymentFrequency={periodicPaymentFrequency}
                withdrawalRequestData={responseModel}
              />
            </div>
          </>
        )}

        <p style={{ fontWeight: "bold" }}>Uploaded Documents</p>
        <div className="distribution-card withdrawal-summary-uploaded-doc mb-3 p-4">
          <div
            className="disp-flex-row justify-content-space-between ml-2"
            style={{ width: "100%" }}
          >
            <div className="disp-flex-col distribution-vertical-line pr-3">
              <p style={{ fontWeight: "bold" }}>Spousal Consent</p>
              {responseModel?.spousalConsentFileUpload ? (
                <>
                  <div className="disp-flex-row">
                    <div className="mr-2">
                      <i
                        className={
                          getFileExtensionFromBlobPath(
                            responseModel?.spousalConsentFileUpload
                          ) === "pdf"
                            ? "fas fa-file-pdf distrbution-word"
                            : getFileExtensionFromBlobPath(
                                responseModel?.spousalConsentFileUpload
                              ) === "png" ||
                              getFileExtensionFromBlobPath(
                                responseModel?.spousalConsentFileUpload
                              ) === "jpg"
                            ? "fas fa-file-image distrbution-word"
                            : "fas fa-file-word distrbution-word"
                        }
                      ></i>
                    </div>
                    <div>
                      <AddToolTip
                        name={
                          getFileNameFromBlobPath(
                            responseModel?.spousalConsentFileUpload
                          ) +
                          "." +
                          getFileExtensionFromBlobPath(
                            responseModel?.spousalConsentFileUpload
                          )
                        }
                      />
                    </div>
                  </div>
                </>
              ) : (
                <div className="d-flex justify-content-left mt-3">
                  <div
                    style={{
                      borderBottom: "3px solid #000",
                      width: "30px",
                    }}
                  ></div>
                </div>
              )}
            </div>

            <div
              className={`disp-flex-col ml-4 ${
                isQBAD ? "distribution-vertical-line pr-3" : ""
              }`}
            >
              <p style={{ fontWeight: "bold" }}>WP_401(k) FORM</p>
              {responseModel?.promissoryNoteFileUpload ? (
                <>
                  <div className="disp-flex-row">
                    <div className="mr-2">
                      <i
                        className={
                          getFileExtensionFromBlobPath(
                            responseModel?.promissoryNoteFileUpload
                          ) === "pdf"
                            ? "fas fa-file-pdf distrbution-word"
                            : getFileExtensionFromBlobPath(
                                responseModel?.promissoryNoteFileUpload
                              ) === "png" ||
                              getFileExtensionFromBlobPath(
                                responseModel?.promissoryNoteFileUpload
                              ) === "jpg"
                            ? "fas fa-file-image distrbution-word"
                            : "fas fa-file-word distrbution-word"
                        }
                      ></i>
                    </div>
                    <div>
                      <AddToolTip
                        name={
                          getFileNameFromBlobPath(
                            responseModel?.promissoryNoteFileUpload
                          ) +
                          "." +
                          getFileExtensionFromBlobPath(
                            responseModel?.promissoryNoteFileUpload
                          )
                        }
                      />
                    </div>
                  </div>
                </>
              ) : (
                <div className="d-flex justify-content-left mt-3">
                  <div
                    style={{
                      borderBottom: "3px solid #000",
                      width: "30px",
                    }}
                  ></div>
                </div>
              )}
            </div>

            {isQBAD && (
              <div className="disp-flex-col ml-4">
                <p style={{ fontWeight: "bold" }}>
                  Adoption or Birth Certificate
                </p>
                {responseModel?.adoptionOrBirthCertificateFileUpload ? (
                  <>
                    <div className="disp-flex-row">
                      <div className="mr-2">
                        <i
                          className={
                            getFileExtensionFromBlobPath(
                              responseModel?.adoptionOrBirthCertificateFileUpload
                            ) === "pdf"
                              ? "fas fa-file-pdf distrbution-word"
                              : getFileExtensionFromBlobPath(
                                  responseModel?.adoptionOrBirthCertificateFileUpload
                                ) === "png" ||
                                getFileExtensionFromBlobPath(
                                  responseModel?.adoptionOrBirthCertificateFileUpload
                                ) === "jpg"
                              ? "fas fa-file-image distrbution-word"
                              : "fas fa-file-word distrbution-word"
                          }
                        ></i>
                      </div>
                      <div>
                        <AddToolTip
                          name={
                            getFileNameFromBlobPath(
                              responseModel?.adoptionOrBirthCertificateFileUpload
                            ) +
                            "." +
                            getFileExtensionFromBlobPath(
                              responseModel?.adoptionOrBirthCertificateFileUpload
                            )
                          }
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="d-flex justify-content-left mt-3">
                    <div
                      style={{
                        borderBottom: "3px solid #000",
                        width: "30px",
                      }}
                    ></div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {responseModel?.withdrawalStatus == 1 && (
          <div
            className="disp-flex-row align-items-center "
            style={{ marginTop: "10px" }}
          >
            <input
              type="checkbox"
              style={{
                height: "18px",
                width: "18px",
                marginRight: "10px",
              }}
            />
            <p style={{ padding: "0px", margin: "0px" }}>
              By checking this box, I declare that I have read the
              <span
                onClick={() => setSliderOpen1(true)}
                className="Light-Blue ml-1"
              >
                Terms and Conditions
              </span>
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default WithdrawalSummaryComponent;
